import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guards-form',
  templateUrl: './guards-form.component.html',
  styleUrls: ['./guards-form.component.css']
})
export class GuardsFormComponent implements OnInit {
  title="Guard Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/guards/guards-form/guards-form.component.ts